
import { Component, Mixins } from "vue-property-decorator";
import { default as DrawableObjectMixin } from "./DrawableObjectMixin.vue";
import { default as ForegroundSwitchableMixin } from "./ForegroundSwitchableMixin.vue";

@Component
export default class ForegroundDrawableObjectMixin extends Mixins(
  DrawableObjectMixin,
  ForegroundSwitchableMixin,
) {
}
